import { codeMasterType } from '../../config/constants';
import modelBase from '../../models/model-base.model';
import codeMasterModel from '../common/code-master.model';

const taskMasterModel = {
  getTaskMasterList: function (successCallBack, failureCallBack, filter) {
    let urlParams = "?TaskName=" + filter.taskName + "&Permission=" + filter.selectedPermission + "&ActionType=" + filter.selectedTypes.join('^') + "&Category="+filter.selectedCategories.join("^") + "&Status=" + filter.selectedStatus + "&PageIndex=" + filter.pageIndex + "&PageSize=" + filter.pageSize + "&OrderBy=" + filter.orderBy + "&sortBy=" + filter.sortBy;
    modelBase.get(successCallBack, failureCallBack, '/api/task' + urlParams);
  },
  getActionTypeList: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/ActionType');
  },
  getMenuMasterList: function (successCallBack, failureCallBack) {

    modelBase.get(successCallBack, failureCallBack, '/api/user/menu/mobile');
  },
  saveTaskMaster: function (successCallBack, failureCallBack, params) {
    modelBase.post(successCallBack, failureCallBack, '/api/task/create', { body: params });
  },
  editTaskMaster: function (successCallBack, failureCallBack, params) {
    modelBase.post(successCallBack, failureCallBack, '/api/task/edit/' + params.taskMstId, { body: params });
  },
  getMasterDetailById: function (successCallBack, failureCallBack, id) {
    modelBase.get(successCallBack, failureCallBack, '/api/task/' + id);
  },
  getTaskCategories: ()=>{
    return codeMasterModel.getByCategoryV2({ category: codeMasterType.taskCategory });
  }

}

export default taskMasterModel;
